const { TrackJS } = require('trackjs');

function install({ doi, env, version }) {
  const token = '4587af51bbb542afbbc9d93bf9567159'
  const application = 'docdel-preview';

  TrackJS.install({ application, token, serialize, onError });
  TrackJS.addMetadata('version', version);
  TrackJS.addMetadata('environment', env);
  TrackJS.addMetadata('doi', doi);
}

function setUser(user) {
  TrackJS.addMetadata('user.id', user.id);
  TrackJS.addMetadata('user.email', user.email);
  TrackJS.addMetadata('organization.id', user.organization?.id);
  TrackJS.addMetadata('organization.name', user.organization?.name);
}

function serialize(obj) {
  return Array.isArray(obj) ? stringifyArr(obj) : stringifyObj(obj);
}

function stringifyObj(o) {
  try {
    return typeof(o) == 'string' ? o : JSON.stringify(o);
  } catch (e) {}
}

function stringifyArr(arr) {
  let strArr = [];
  for (let i = 0; i < arr.length; i++) {
    strArr.push(stringifyObj(arr[i]));
  }
  return strArr.join(' ');
}

function onError(payload) {
  if (/\/\/api\.altmetric\.com\/v1\/doi/.test(payload.message)) return false;
  if (/\/\/metrics-api\.dimensions\.ai\/doi/.test(payload.message)) return false;

  const status = window.status_response || {};
  const docdel = window.docdel_response || {};

  Object.keys(status).forEach(key => {
    payload.metadata.push({
      key: `status.${key}`,
      value: serialize(status[key])
    });
  });

  Object.keys(docdel).forEach(key => {
    payload.metadata.push({
      key: `docdel.${key}`,
      value: serialize(docdel[key])
    });
  });

  return true;
}

module.exports = { install, setUser };
